import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
// @ts-ignore
import BcDialog from '@/components/Dialog.vue';
import imageCompression from 'browser-image-compression';
let FlowStepUphold = class FlowStepUphold extends Vue {
    constructor() {
        super(...arguments);
        this.deviceData = {}; // 设备数据
        this.flowCheckInfo = {}; // 设备流程核对信息
        this.queryType = ''; // 页面类型
        this.snackbar = new CBcSnackbar();
        this.loading = false;
        this.searchForm = {
            keyword: '',
            displayOption: 0,
        };
        this.productCategory = [];
        this.flowUphold = [];
        this.dialogFlow = {
            visible: false,
            loading: false,
            title: '',
            operType: 'add',
            form: false,
            index: 0,
            isPass: true,
            formData: {},
        };
        this.curDevFlowInfo = {}; // 当前设备流程核对信息
        this.imageFile = null;
        /** 预览类型：image=图片 video=视频 pdf=PDF流式预览 document=Office等仅下载 */
        this.previewList = []; // item: { url, previewType: 'image'|'video'|'pdf'|'document', name? }
        this.idList = [];
        /** 允许上传的 MIME / 扩展：图片、视频、PDF、Office */
        this.uploadAccept = 'image/*,video/*,.mp4,.webm,.mov,.avi,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx';
        /** 视频最大体积 50MB */
        this.maxVideoSizeMB = 50;
        /** 文档最大体积 10MB */
        this.maxDocSizeMB = 10;
        /** 单张图片最大 1MB（压缩后） */
        this.maxImageSizeMB = 1;
        this.showOverlay = false;
        /** 大图/视频 overlay 类型：image | video */
        this.previewMediaType = 'image';
        this.screenWidth = window.innerWidth * 0.9; // 屏幕宽度（90%用于留白）
        this.screenHeight = window.innerHeight * 0.9; // 屏幕高度（90%用于留白）
        // 查看产品明细
        this.dialogDetail = {
            visible: false,
            formData: {},
        };
        this.dialogProduct = {
            visible: false,
            loading: false,
            title: '',
            operType: 'add',
            form: false,
            imageUrl: null,
            formData: {},
        };
        this.devCheckFlowList = [];
    }
    /** 是否为图片类型（用于前端压缩与预览） */
    isImageType(file) {
        if (!file || !file.type)
            return false;
        return /^image\//i.test(file.type);
    }
    /** 是否为视频类型 */
    isVideoType(file) {
        if (!file || !file.type)
            return false;
        return /^video\//i.test(file.type);
    }
    /** 是否为 PDF（用于流式预览） */
    isPdfType(file) {
        if (!file || !file.type)
            return false;
        return file.type.toLowerCase() === 'application/pdf';
    }
    /** 是否为允许的文档类型（PDF、Office） */
    isAllowedDocType(file) {
        if (!file || !file.type)
            return false;
        const t = file.type.toLowerCase();
        return t === 'application/pdf' ||
            t === 'application/msword' ||
            t === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
            t === 'application/vnd.ms-excel' ||
            t === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
            t === 'application/vnd.ms-powerpoint' ||
            t === 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
    }
    /** 单文件是否在允许范围内 */
    isAllowedFile(file) {
        return this.isImageType(file) || this.isVideoType(file) || this.isAllowedDocType(file);
    }
    /** 根据 url 或文件名推断预览类型（用于回显） */
    inferPreviewType(url, name) {
        let source = (name || url || '').toLowerCase();
        // 处理 /api/storage/files?key=devCheck%2Fxxx.pdf 这类地址，取 key 并反解码
        const keyIndex = source.indexOf('key=');
        if (keyIndex >= 0) {
            const keyPart = source.substring(keyIndex + 4);
            try {
                source = decodeURIComponent(keyPart);
            }
            catch (e) {
                source = keyPart;
            }
        }
        else {
            // 普通 URL：去掉 query 部分
            const qIndex = source.indexOf('?');
            if (qIndex >= 0)
                source = source.substring(0, qIndex);
        }
        if (/\.(pdf)(\?|$)/i.test(source))
            return 'pdf';
        if (/\.(mp4|webm|mov|avi|m4v)(\?|$)/i.test(source))
            return 'video';
        if (/\.(doc|docx|xls|xlsx|ppt|pptx)(\?|$)/i.test(source))
            return 'document';
        return 'image';
    }
    // @Watch('dialogFlow.index')
    // onDialogFlowChanged(v: any, o: any) {
    //   if (v === o || !this.devCheckFlowList.length) return
    //   this.imageFile = null
    //   this.imagePreviewUrl = []
    //   this.dialogFlow.isPass = true;
    //   this.getCurDevCheckRecord(null)
    // }
    /** 选择文件后上传：图片先压缩再上传，PDF/Office 直接上传 */
    async submit() {
        const that = this;
        if (!this.imageFile || !this.imageFile.length)
            return;
        const files = Array.isArray(this.imageFile) ? this.imageFile : [this.imageFile];
        try {
            for (const file of files) {
                if (!file || !(file instanceof File))
                    continue;
                if (!that.isAllowedFile(file)) {
                    that.snackbar.warn(`不支持的文件类型：${file.name || file.type}，请上传图片、视频、PDF 或 Office 文档`);
                    continue;
                }
                const isImage = that.isImageType(file);
                const isVideo = that.isVideoType(file);
                const isPdf = that.isPdfType(file);
                const isDoc = that.isAllowedDocType(file);
                if (isImage) {
                    const options = { maxSizeMB: that.maxImageSizeMB, maxWidthOrHeight: 1024, useWebWorker: true };
                    const compressedFile = await imageCompression(file, options);
                    const fileType = compressedFile.type;
                    const fileSize = compressedFile.size / 1024 / 1024;
                    if (fileSize > that.maxImageSizeMB) {
                        that.snackbar.warn(`单个图片大小不能超过 ${that.maxImageSizeMB}MB`);
                        continue;
                    }
                    const baseName = (file.name && file.name.replace(/\.[^.]+$/, '')) || 'image';
                    const fileExtension = (fileType && fileType.split('/')[1]) || 'jpg';
                    const filename = `${baseName}.${fileExtension}`;
                    const fileToUpload = new File([compressedFile], filename, { type: fileType });
                    const formData = new FormData();
                    formData.append('image', fileToUpload);
                    const res = await that.axios.post('/api/upload/files', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });
                    const data = (res.data && res.data.result) || {};
                    const url = (data.host || '') + (data.url || '');
                    that.previewList.push({ url, previewType: 'image', name: file.name });
                    that.idList.push({ id: data.id, url, previewType: 'image', name: file.name });
                }
                else if (isVideo) {
                    const fileSize = file.size / 1024 / 1024;
                    if (fileSize > that.maxVideoSizeMB) {
                        that.snackbar.warn(`视频大小不能超过 ${that.maxVideoSizeMB}MB：${file.name}`);
                        continue;
                    }
                    const formData = new FormData();
                    formData.append('image', file);
                    const res = await that.axios.post('/api/upload/files', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });
                    const data = (res.data && res.data.result) || {};
                    const url = (data.host || '') + (data.url || '');
                    that.previewList.push({ url, previewType: 'video', name: file.name });
                    that.idList.push({ id: data.id, url, previewType: 'video', name: file.name });
                }
                else if (isDoc) {
                    const fileSize = file.size / 1024 / 1024;
                    if (fileSize > that.maxDocSizeMB) {
                        that.snackbar.warn(`文档大小不能超过 ${that.maxDocSizeMB}MB：${file.name}`);
                        continue;
                    }
                    const formData = new FormData();
                    formData.append('image', file);
                    const res = await that.axios.post('/api/upload/files', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });
                    const data = (res.data && res.data.result) || {};
                    const url = (data.host || '') + (data.url || '');
                    const previewType = isPdf ? 'pdf' : 'document';
                    that.previewList.push({ url, previewType, name: file.name });
                    that.idList.push({ id: data.id, url, previewType, name: file.name });
                }
            }
            that.imageFile = null;
        }
        catch (error) {
            that.loading = false;
            that.imageFile = null;
            that.snackbar.error('上传失败', error);
        }
    }
    /** 保存维护记录 */
    async saveFlowStepForm(imageInfo = null) {
        const that = this;
        that.loading = true;
        const imageUploadInfo = imageInfo || (this.previewList || []).map((item) => (item && item.url) || item);
        if (this.flowCheckInfo.isConfirm == '1' && (!imageUploadInfo || !imageUploadInfo.length)) {
            that.loading = false;
            return that.snackbar.warn('请上传图片、视频或文档资料后再提交！');
        }
        try {
            // 匹配 imageUploadInfo 中的 URL 和 this.idList 中的 URL
            const idList = (imageUploadInfo || []).map((url) => {
                const matchedItem = (this.idList || []).find((item) => item.url === url); // 查找 URL 匹配的项
                return matchedItem ? matchedItem.id : null; // 如果找到匹配的 URL，则返回 id，否则返回 null
            }).filter((id) => id !== null); // 过滤掉 null 值
            const requestInfo = {
                hospitalId: that.deviceData.hospitalId,
                receiptId: that.deviceData.receiptId,
                erpOrderNo: that.deviceData.orderNumber,
                flowId: that.flowCheckInfo.flowId,
                flowStepId: that.flowCheckInfo.id,
                idList: JSON.stringify(idList),
                isPass: true,
                remark: that.dialogFlow.formData.description
            };
            await that.axios.post('/api/devCheck/flowRecord', requestInfo).then((res) => {
                if (res.data.result && res.data.result.id) {
                    that.loading = false;
                    this.imageFile = null;
                    this.backToFlow();
                }
                else {
                    that.snackbar.error('保存失败', res.data.result);
                }
                that.loading = false;
            });
        }
        catch (error) {
            console.log('saveFlowStepForm error', error);
            that.loading = false;
            that.snackbar.error('保存失败');
        }
    }
    // updateImagePreview() {
    //   if (this.imageFile) {
    //     const file = this.imageFile;
    //     file.forEach((file: any) => {
    //       this.imagePreviewUrl.push(URL.createObjectURL(file));
    //     });
    //   } else {
    //     this.imagePreviewUrl = [];
    //   }
    // }
    /** 获取确认流程列表 */
    async getCurDevCheckRecord(stepId) {
        const that = this;
        const queryParams = {
            receiptId: that.deviceData.receiptId,
            flowId: that.flowCheckInfo.flowId,
            flowStepId: stepId || that.dialogFlow.formData.id
        };
        const res = await that.axios.get('/api/devCheck/flowRecord/' + 0, { params: queryParams });
        const list = res.data.result && res.data.result.rows || [];
        that.curDevFlowInfo = list.length ? list[0] : {};
        that.dialogFlow.formData.description = '';
        that.previewList = [];
        this.idList = [];
        if (that.curDevFlowInfo && that.curDevFlowInfo.id) {
            that.dialogFlow.formData.description = that.curDevFlowInfo.remark;
            const imageUrls = that.curDevFlowInfo.imageUrl ? JSON.parse(that.curDevFlowInfo.imageUrl) : [];
            const rawIdList = that.curDevFlowInfo.idList ? JSON.parse(that.curDevFlowInfo.idList) : [];
            const maxLen = Math.max(imageUrls.length, rawIdList.length);
            this.idList = [];
            that.previewList = [];
            for (let i = 0; i < maxLen; i += 1) {
                const url = imageUrls[i];
                if (!url)
                    continue;
                const rawId = rawIdList[i];
                const id = typeof rawId === 'object' && rawId !== null ? rawId.id : rawId;
                const name = (typeof rawId === 'object' && rawId && rawId.name) || (url && url.split('/').pop()) || '';
                const previewType = that.inferPreviewType(url, name);
                const item = { id, url, previewType, name };
                this.idList.push(item);
                that.previewList.push({ url, previewType, name });
            }
            that.dialogFlow.isPass = !/null|0|false/i.test(that.curDevFlowInfo.isPass);
        }
    }
    /** 获取确认流程列表 */
    async getDevCheckFlowStep() {
        const that = this;
        that.loading = true;
        try {
            const res = await that.axios.get('/api/devCheck/flowStep/' + this.flowCheckInfo.id);
            that.devCheckFlowList = (res.data.result && res.data.result.rows || []);
            if (!that.devCheckFlowList.length) {
                that.snackbar.warn('流程核对步骤为空，请先维护');
            }
            else {
                that.dialogFlow.formData = that.devCheckFlowList[0] || {};
                this.getCurDevCheckRecord(that.dialogFlow.formData.id);
            }
            that.loading = false;
        }
        catch (e) {
            that.loading = false;
        }
    }
    backToFlow() {
        const that = this;
        this.deviceData.activeTab = this.goBackTabIndex;
        that.$router.push({
            name: 'FlowUphold',
            params: this.deviceData
        });
    }
    backToIndex() {
        const that = this;
        that.$router.push({
            name: 'CheckFlow',
        });
    }
    async mounted() {
        const that = this;
        const deviceInfo = JSON.parse(that.$route.params.deviceInfo || '{}');
        const flowCheckData = JSON.parse(that.$route.params.flowCheckInfo || '{}');
        if (!deviceInfo || (Object.keys(deviceInfo).length === 0 && deviceInfo.constructor === Object) || !flowCheckData) {
            that.backToIndex();
        }
        this.queryType = deviceInfo.queryType || '';
        this.goBackTabIndex = that.$route.params.activeTab || 0;
        this.deviceData = deviceInfo;
        this.flowCheckInfo = flowCheckData; // 流程步骤信息
        await this.getDevCheckFlowStep();
        this.dialogFlow.isPass = true;
    }
    closeOverlay() {
        this.previewImg = '';
        this.previewMediaType = 'image';
        this.showOverlay = false;
    }
    openOverlay(url, mediaType = 'image') {
        this.previewImg = url;
        this.previewMediaType = mediaType;
        this.showOverlay = true;
    }
    /** 删除图片/文档：调用后端删除文件及数据库记录，并同步本地 idList/previewList */
    async deleteImg(stepIndex) {
        const that = this;
        const item = (that.idList || [])[stepIndex];
        if (!item || item.id == null) {
            that.previewList.splice(stepIndex, 1);
            that.idList.splice(stepIndex, 1);
            return;
        }
        try {
            await that.axios.delete(`/api/upload/files/${item.id}`);
            that.previewList.splice(stepIndex, 1);
            that.idList.splice(stepIndex, 1);
            that.snackbar.success('已删除');
        }
        catch (e) {
            that.snackbar.error('删除失败：' + (e && (e.response && e.response.data && e.response.data.error) || e.message || e));
        }
    }
};
FlowStepUphold = __decorate([
    Component({
        name: 'FlowStepUphold',
        components: {
            BcSnackbar,
            BcDialog,
        },
    })
], FlowStepUphold);
export default FlowStepUphold;
